import * as preact from "preact";

interface Props {
  /** The shape of what's loading: the Library's cards, list rows, or page sections */
  kind: "cards" | "rows" | "blocks";
  count?: number;
}

/** Shimmering grey shapes in place of content that's loading */
export default class SkeletonView extends preact.Component<Props> {
  render() {
    const { kind, count = 4 } = this.props;
    return (
      <div class={`skeleton ${kind}`} role="progressbar" aria-label="Loading">
        {Array.from({ length: count }, (_, index) => (
          <div key={index} class="skeletonItem">
            <div class="skeletonLine" />
            <div class="skeletonLine short" />
          </div>
        ))}
      </div>
    );
  }
}
